import React from "react"
import { Trans, useTranslation } from "react-i18next"
import { Video } from "../Video.jsx"
import { AccessTokenForm } from "./AccessTokenForm.jsx"
import { ShopDomainForm } from "./ShopDomainForm.jsx"

export const Step3 = ({
	randomAppNameButton,
	accessToken,
	setAccessToken,
	showOverrideShopDomainInput,
	overrideShopDomain,
	setOverrideShopDomain,
}) => {
	const { t } = useTranslation()

	const KopyOnboardingVideo3 =
		"https://kopy.b-cdn.net/kopy-onboarding-3-new.webm"

	return (
		<div
			style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
		>
			<div style={{ width: "100%", height: "auto" }}>
				<Video videoSrc={KopyOnboardingVideo3} />
			</div>

			<h1
				style={{
					marginTop: "1rem",
					marginBottom: "1rem",
					fontSize: "1.2rem",
					fontWeight: "600",
					color: "#222",
					lineHeight: "1.1",
				}}
			>
				{t("link_store.step_3")}
			</h1>

			<p
				style={{
					fontSize: "0.85rem",
					fontWeight: "400",
					color: "#333",
					lineHeight: "1.3",
				}}
			>
				<Trans
					i18nKey="link_store.step_3_1"
					components={{ b: <b></b>, randomAppNameButton }}
				></Trans>
			</p>
			<p
				style={{
					fontSize: "0.85rem",
					fontWeight: "400",
					color: "#333",
					lineHeight: "1.3",
				}}
			>
				<Trans
					i18nKey="link_store.step_3_2"
					components={{ b: <b></b> }}
				></Trans>
			</p>
			<p
				style={{
					fontSize: "0.85rem",
					fontWeight: "400",
					color: "#333",
					lineHeight: "1.3",
				}}
			>
				<Trans
					i18nKey="link_store.step_3_3"
					components={{ b: <b></b> }}
				></Trans>
			</p>
			<div
				style={{
					padding: "1rem",
					background: "#E51C01",
					fontSize: "0.9rem",
					color: "white",
					borderRadius: "0.5rem",
					margin: "0.5rem 0rem",
				}}
			>
				<Trans
					i18nKey="link_store.step_3_warning"
					components={{ b: <b></b> }}
				></Trans>
			</div>

			<p
				style={{
					fontSize: "0.85rem",
					fontWeight: "400",
					color: "#333",
					lineHeight: "1.3",
				}}
			>
				<Trans
					i18nKey="link_store.step_3_4"
					components={{ b: <b></b> }}
				></Trans>
			</p>

			<div
				style={{
					padding: "2rem 0rem",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexDirection: "column",
					gap: "1rem",
				}}
			>
				<AccessTokenForm
					accessToken={accessToken}
					setAccessToken={setAccessToken}
				/>
				{showOverrideShopDomainInput && (
					<ShopDomainForm
						overrideShopDomain={overrideShopDomain}
						setOverrideShopDomain={setOverrideShopDomain}
					/>
				)}
			</div>
		</div>
	)
}
